export const FIELD_TYPES = {
  PASSWORD: "password",
  LIST: "list",
  TEXT: "text",
  INTEGER: "int",
  BOOLEAN: "boolean",
};
